import { AddressType } from '../../constants/address-type.js';
import { ADDRESS_CONSTRAINTS } from '../address/constraints.js';
/** Day 1 customer addresses: one Billing and one Shipping per record (R4). */
export const CustomerAddressType = {
    SHIPPING: AddressType.SHIPPING,
    BILLING: AddressType.BILLING,
};
const customerAddressTypeIds = Object.values(CustomerAddressType);
export function isCustomerAddressTypeId(typeId) {
    return customerAddressTypeIds.includes(typeId);
}
export function customerAddressTypeLabel(typeId) {
    switch (typeId) {
        case AddressType.SHIPPING:
            return 'Shipping';
        case AddressType.BILLING:
            return 'Billing';
        default:
            return 'Address';
    }
}
export function customerAddressTypeTakenMessage(typeId) {
    switch (typeId) {
        case AddressType.BILLING:
            return 'A billing address already exists for this customer.';
        case AddressType.SHIPPING:
            return 'A shipping address already exists for this customer.';
        default:
            return 'An address of this type already exists for this customer.';
    }
}
/** Type ids that cannot be added given existing addresses (for create/edit type controls). */
export function unavailableCustomerAddressTypeIds(addresses, excludeAddressId) {
    const active = excludeAddressId === undefined
        ? addresses
        : addresses.filter((address) => address.id !== excludeAddressId);
    return [
        ...new Set(active
            .map((address) => address.addressType?.id)
            .filter((typeId) => Boolean(typeId))),
    ];
}
export function canAddCustomerAddress(addresses) {
    const unavailable = new Set(unavailableCustomerAddressTypeIds(addresses));
    return Object.values(CustomerAddressType).some((typeId) => !unavailable.has(String(typeId)));
}
/** Default nickname when the user has not entered one yet. */
export function suggestCustomerAddressName(customerName, typeId) {
    const typeLabel = customerAddressTypeLabel(typeId);
    return `${customerName} - ${typeLabel}`.slice(0, ADDRESS_CONSTRAINTS.addressName.maxLength);
}
//# sourceMappingURL=rules.js.map